<epay-page-content [pagetitle]="pagetitle">
  <!-- TODO: user flow for employer / ncp; existing / new user; ACH / credit -->
  <div class="page-content-main max-w max-gs t-alignC mb-3">
    <div class="message-panel" *ngIf="message1">
      <div class="box-panel">
        <p class="c-red1b">{{message1}}</p>
        <p class="c-red1b">{{message2}}</p>
        <p class="c-red1b">{{message3}}</p>
      </div>
    </div>
    <br>
  </div>

  <div class="page-content-main max-w max-gxs t-alignC" id="page-content-main">
    <div class="box-panel ie-note mb-5" *ngIf="isIE">
      <div class="small-note-block alert-note">
        <p class="c-red1">
          {{ieMessage}}
        </p>
      </div>
    </div>
  </div>
    <div class="page-content-main max-w max-gxs t-alignC" id="page-content-main">
    <div class="box-panel translucent-panel access-panel mb-5">
      <p class="mb-3">The West Virginia Child Support Payment Portal is a secure resource for noncustodial parents and employers to make child 
        support payments, initiate income withholding, or receive assistance with the child support payment process. 
      </p>
      
      <div class="access-links mx-3 mt-3">
        <div class="">
          <a class="db btn-link mt-3" [routerLink]="['/login']">Login</a>
          <a class="db btn-link mt-3" [routerLink]="['/register']">Create Account</a>
          <a class="db btn-link mt-3" [routerLink]="['/ncp/creditcard']">NCP Credit Card Payment</a>
          <a class="db btn-link mt-3" [routerLink]="['/ncp/cash-payment']">NCP Cash Payment</a>
        </div>
      </div>

      <div class="small-note-block mx-3 mb-3" style="padding-top: 10px;">
        <p class="">Make a child support payment using a credit card by phone at:
          <STRONG class="mx-1">1-855-303-0094</STRONG></p>
      </div>

      <div class="small-note-block alert-note mb-2 mx-3 alert border border-danger">
        <p class="c-red1">This Website Does Not Accept Payments Drawn on a Foreign Bank Account</p>
      </div>

      <div class="small-note-block xs-note mt-3">
        <p>Note: This website requires that cookies be enabled in your
          browser. By accessing this site, you agree to have cookies stored on your computer. You can read more about
          how this site uses cookies in our <a [routerLink]="['/privacypolicy']" style="font-weight:bold">Privacy Policy</a>
        </p>
      </div>
    </div>

  </div>
</epay-page-content>
